import { User } from "./User";
import { Client } from "./Client";
import { Company } from "./Company";

/**
 * Interface for a user with client information enriched
 */
export interface ProjectClientUser extends User {
  client?: Client;
}

/**
 * Interface for a user with internal information enriched
 */
export interface ProjectInternalUser extends User {
  // Internal users might have additional properties in the future
  company?: Company;
  jobTitle?: string;
  isLead?: boolean;
}

/**
 * Union type for project users (can be either client or internal)
 */
export type ProjectUser = ProjectClientUser | ProjectInternalUser;

/**
 * Helper function to check if a user is a client user
 */
export function isProjectClientUser(user: ProjectUser): user is ProjectClientUser {
  return 'client' in user && user.client !== undefined;
}

/**
 * Helper function to check if a user is an internal user
 */
export function isProjectInternalUser(user: ProjectUser): user is ProjectInternalUser {
  return !isProjectClientUser(user);
}